import { GET_HELPER_DATA } from '../actions/data';

const initialState = {
    role_list: [],
    status_list: [],
    // The `:service` segment of every /api/v1/:service/admin/… call. The backend
    // ignores its value (there is no sandbox), so it is fixed rather than
    // switchable: a «Sandbox» choice would still edit production data.
    service: 'production',
};

const reducer = (state: any = initialState, action: any) => {
    switch (action.type) {
        case GET_HELPER_DATA:
            return {
                ...state,
                role_list: action.payload.role_list,
                status_list: action.payload.status_list,
            };
        default:
            return state;
    }
};

export default reducer;
